import { Check, X, Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";

export const ShapeToolbar = ({ edit, onEdit, onSave, onCancel, label }) => {
  const canRemove = edit.selected != null && edit.points.length > 3;
  const remove = () => onEdit({ ...edit, points: edit.points.filter((_, i) => i !== edit.selected), selected: null });
  return (
    <div className="absolute left-3 right-3 top-20 z-30 rounded-md border border-[#D97706]/50 bg-[#13171F]/90 p-3 backdrop-blur-md sm:left-1/2 sm:right-auto sm:w-[520px] sm:-translate-x-1/2" data-testid="shape-toolbar">
      <div className="mb-2 text-sm text-[#F3EBDD]">Reshaping <span className="font-display text-lg text-[#F59E0B]">{edit.name}</span></div>
      <p className="mb-3 text-xs text-[#A8A090]">Drag corners to move them. Tap a + to add a corner. Tap a corner then Remove (or double-tap it) to delete it.</p>
      <div className="flex flex-wrap items-center gap-2">
        <Button size="sm" variant="ghost" className="text-red-300" disabled={!canRemove} onClick={remove} data-testid="shape-remove-vertex"><Trash2 className="mr-1 h-3.5 w-3.5" />Remove corner</Button>
        <span className="flex-1" />
        <Button size="sm" variant="outline" onClick={onCancel} data-testid="shape-cancel"><X className="mr-1 h-3.5 w-3.5" />Cancel</Button>
        <Button size="sm" onClick={onSave} data-testid="shape-save"><Check className="mr-1 h-3.5 w-3.5" />{label}</Button>
      </div>
    </div>
  );
};
